// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5a6654a8","667":"3dc85634"}[chunkId] + ".chunk.js";
};